export default __webpack_public_path__ + "static/media/Tulis.2d472237.gif";